import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import userActions from '../../user/userActions';

import CustomerNotesList from './CustomerNotesList';
import CustomerNotesListOptions from './CustomerNotesListOptions';
import CustomerNoteDetails from './CustomerNoteDetails';

import { ensureUserHasRoleAdminSite } from '../../auth/authComponents';
import Utils, { SecurityRoles as roles } from '../../common/utils';

interface Props {
	customer: UserDetails;
	className?: string;
	notes: CustomerNote[];
	note: CustomerNote;
	actions: any;
	history: any;
	match: any;
}
interface State {
	notes: CustomerNote[];
	searchterm: string;
}
class CustomerNotesPage extends React.Component<Props, State> {
	handleSearchDebounced = Utils.debounce(() => { this.search(this.state.searchterm); }, 200);

	constructor(props: Props) {
		super(props);
		this.state = {
			notes: [],
			searchterm: ''
		};
	}

	componentDidMount() {
			this.props.actions.fetchCustomerNotes(this.props.match.params.customerId)
				.then(() => this.setState({ notes: this.props.notes }));

	}

	componentWillReceiveProps(nextProps: Props) {
		if (this.props.match.params.pageId !== nextProps.match.params.pageId) {
			if (nextProps.match.params.pageId && nextProps.match.params.pageId !== 'new') {
				this.props.actions.fetchCustomerNote(nextProps.match.params.customerId, nextProps.match.params.pageId);
			}
			else {
				this.props.actions.fetchCustomerNotes(nextProps.match.params.customerId)
					.then(() => this.setState({ notes: this.props.notes }));
		}
		}
	}

	addNotes = () => {
		if (!window.location.href.includes('prospects')) {
			return this.props.history.push(`/admin/customers/${this.props.match.params.customerId}/notes/new`);
		} else {
			return this.props.history.push(`/admin/prospects/${this.props.match.params.customerId}/notes/new`);
		}
	}

	onSearch = (e: any) => {
		this.setState({ searchterm: e.target.value }, () => {
			this.handleSearchDebounced();
		});
	}
	search = (searchterm: string) => {
		const value = searchterm.toLowerCase();
		let notes = this.props.notes.filter(function (n: CustomerNote) {
			let date = Utils.formatDate(n.createdDate);
			let note = n.notes || '';
			return (
				note.toLowerCase().startsWith(value)
				|| date.toLowerCase().startsWith(value)
			);
		});

		this.setState({ notes });
	}

	renderNotesList = () => {
		return (
			<div className="content-set">
				<CustomerNotesListOptions
					addNotes={this.addNotes}
					searchterm={this.state.searchterm}
					onSearch={this.onSearch}
				/>
				<CustomerNotesList
					notes={this.state.notes}
					history={this.props.history}
					match={this.props.match}
					hasStripeId={this.props.customer.stripeCustomerId ? true : false}
				/>
			</div>
		);
	}

	renderNoteForm = () => {
		return <CustomerNoteDetails {...this.props} />;
	}

	render() {
		if (this.props.match.params.pageId) {
			return this.renderNoteForm();
		}
		else {
			return this.renderNotesList();
		}
	}
}
function mapStateToProps(state: any) {
	return {
		notes: state.user.notes,
		note: state.user.note
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...userActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const connectedPage = connect(mapStateToProps, mapDispatchToProps)(CustomerNotesPage);
const adminRoles = [roles.Administrator, roles.Agent, roles.Adjudicator];
export default ensureUserHasRoleAdminSite(connectedPage as any, adminRoles);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/CustomerNotesPage.tsx